// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"3ab1e7f8","210":"747ee439","244":"7a1e999e","400":"b16926d0","414":"01e2f519","453":"2f919960","522":"774fe93d","544":"76b529f1","586":"e3cbb2a0","618":"34d9c224","645":"dd63a002","683":"16843d63","789":"f7ced24b"}[chunkId] + ".chunk.js";
};